import React from 'react'
import { useDetailTheme } from '../../DetailContext'
import Icon from 'src/shared/icons'
import { IconNamesProps } from 'src/shared/icons/Icon'
import './DetailIcon.css'

const DetailIcon = (iconProps: IconNamesProps ) => {
    const { color } = useDetailTheme()

    return (
        <div className='drawer-detail__icon'>
            <Icon {...iconProps} width={16} height={16} color={iconProps.color || color} />
        </div>
    )
}

export default DetailIcon
